import { render, staticRenderFns } from "./Interprets.vue?vue&type=template&id=2d914d1b&scoped=true&"
import script from "./Interprets.vue?vue&type=script&lang=js&"
export * from "./Interprets.vue?vue&type=script&lang=js&"
import style0 from "./Interprets.vue?vue&type=style&index=0&id=2d914d1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d914d1b",
  null
  
)

export default component.exports